function routeEntryKey(routerRoot, routeFile) {
  return `/${routerRoot}/${routeFile.replace(/^\.?\//, "")}`;
}
async function getRouteExportsFromEntry(entry, routerRoot, routeFile) {
  var _entry_default, _entry_default1, _app_options_routes, _app_options;
  var key = routeEntryKey(routerRoot, routeFile);
  var spaExports = entry === null || entry === void 0 ? void 0 : entry.oneServerSpaRouteExports;
  if ((spaExports === null || spaExports === void 0 ? void 0 : spaExports.loader) && key in spaExports.loader) {
    var _spaExports_loaderCache_key, _spaExports_loaderCache, _spaExports_generateStaticParams_key, _spaExports_generateStaticParams, _spaExports_sitemap_key, _spaExports_sitemap;
    var [loader, loaderCache, generateStaticParams, sitemap] = await Promise.all([
      spaExports.loader[key](),
      (_spaExports_loaderCache = spaExports.loaderCache) === null || _spaExports_loaderCache === void 0 ? void 0 : (_spaExports_loaderCache_key = _spaExports_loaderCache[key]) === null || _spaExports_loaderCache_key === void 0 ? void 0 : _spaExports_loaderCache_key.call(_spaExports_loaderCache),
      (_spaExports_generateStaticParams = spaExports.generateStaticParams) === null || _spaExports_generateStaticParams === void 0 ? void 0 : (_spaExports_generateStaticParams_key = _spaExports_generateStaticParams[key]) === null || _spaExports_generateStaticParams_key === void 0 ? void 0 : _spaExports_generateStaticParams_key.call(_spaExports_generateStaticParams),
      (_spaExports_sitemap = spaExports.sitemap) === null || _spaExports_sitemap === void 0 ? void 0 : (_spaExports_sitemap_key = _spaExports_sitemap[key]) === null || _spaExports_sitemap_key === void 0 ? void 0 : _spaExports_sitemap_key.call(_spaExports_sitemap)
    ]);
    return {
      loader,
      loaderCache,
      generateStaticParams,
      sitemap
    };
  }
  var app = (entry === null || entry === void 0 ? void 0 : (_entry_default = entry.default) === null || _entry_default === void 0 ? void 0 : _entry_default.options) ? entry.default : entry === null || entry === void 0 ? void 0 : (_entry_default1 = entry.default) === null || _entry_default1 === void 0 ? void 0 : _entry_default1.default;
  var importRoute = app === null || app === void 0 ? void 0 : (_app_options = app.options) === null || _app_options === void 0 ? void 0 : (_app_options_routes = _app_options.routes) === null || _app_options_routes === void 0 ? void 0 : _app_options_routes[key];
  return importRoute ? await importRoute() : null;
}
export {
  getRouteExportsFromEntry,
  routeEntryKey
};
//# sourceMappingURL=routeExportsFromEntry.js.map
